<!-- @format -->

<!-- TODO: remove trapFocus and restoreFocus() and fix focus trap in homefield -->
<hmf-modal
	className="review-modal"
	[transparentBackground]="false"
	[focus]="true"
	[interactability]="false"
	[closableVariant]="'primary'"
	[trapFocus]="true"
	[isCloseButtonSticky]="hasNewReviewsEnhancement"
	(closed)="closeModalEvt()"
	(keydown)="onKeydownEvent($event)">
	<product-reviews-review-section
		class="review-section"
		[hasNewReviewsEnhancement]="hasNewReviewsEnhancement"></product-reviews-review-section>
</hmf-modal>
